import type { AdminViewDefinition } from "../../components/admin-components.js";
import { installationDashboardView } from "../operations/operation-pages.js";

export const authAdminViews: AdminViewDefinition[] = [
  loginView(),
  loginDeniedView(),
  sessionExpiredView(),
  readOnlyAdminView(),
  roleRevokedView(),
];

function loginView(): AdminViewDefinition {
  return {
    id: "login",
    navId: "settings",
    kind: "auth",
    title: "Sign in to Price Rescue Admin",
    description: "Only allowlisted internal users can access this application.",
    environment: "Production",
    actions: [{ label: "Continue with Cognito", variant: "primary" }],
    callouts: [
      {
        title: "Security boundary",
        body: "No merchant platform credentials are used for System Admin access.",
        tone: "blue",
      },
    ],
  };
}

function loginDeniedView(): AdminViewDefinition {
  return {
    id: "login-denied",
    navId: "settings",
    kind: "auth",
    title: "Access denied",
    description:
      "Your Cognito identity is valid, but this email or role is not allowlisted for Price Rescue Admin.",
    state: {
      title: "Production access denied",
      description:
        "avery.contractor@example.net cannot access this environment. This denial is recorded in the security audit log.",
      tone: "red",
      actions: [{ label: "Sign out" }, { label: "Contact internal security", variant: "primary" }],
    },
  };
}

function sessionExpiredView(): AdminViewDefinition {
  return {
    id: "session-expired",
    navId: "settings",
    kind: "auth",
    title: "Your admin session expired",
    description: "Return to Cognito login to continue with a fresh admin session.",
    state: {
      title: "Your admin session expired",
      description: "Idle and absolute timeouts protect production admin access.",
      tone: "orange",
      actions: [{ label: "Return to Cognito login", variant: "primary", routeId: "login" }],
    },
  };
}

function readOnlyAdminView(): AdminViewDefinition {
  return {
    ...installationDashboardView(),
    id: "read-only-admin",
    callouts: [
      {
        title: "Read-only admin",
        body: "Mutation actions are hidden or disabled for READ_ONLY_ADMIN sessions.",
        tone: "orange",
      },
    ],
  };
}

function roleRevokedView(): AdminViewDefinition {
  return {
    id: "role-revoked",
    navId: "settings",
    kind: "auth",
    title: "Your System Admin role was revoked",
    description: "Your current session can no longer access internal operations.",
    state: {
      title: "Your System Admin role was revoked",
      description:
        "Sign out and contact internal security if you believe this changed unexpectedly.",
      tone: "red",
      actions: [{ label: "Sign out", variant: "primary" }],
    },
  };
}
